import { render, staticRenderFns } from "./PharmacyFilterModule.vue?vue&type=template&id=35825696&"
import script from "./PharmacyFilterModule.vue?vue&type=script&lang=js&"
export * from "./PharmacyFilterModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports